export function headerDropdown() {
  const langBtns = document.querySelectorAll('.lang-btn');

  if (!langBtns.length) return;

  const path = window.location.pathname;

  langBtns.forEach((langBtn) => {
    const dropdown = langBtn.querySelector('.lang-btn__dropdown');
    const langLinks = langBtn.querySelectorAll('.lang-btn__dropdown-link');

    if (!dropdown) return;

    langBtn.addEventListener('click', (e) => {
      e.stopPropagation();

      langBtn.classList.toggle('lang-btn--active');
      dropdown.classList.toggle('lang-btn__dropdown--active');
    });

    dropdown.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    document.addEventListener('click', () => {
      langBtn.classList.remove('lang-btn--active');
      dropdown.classList.remove('lang-btn__dropdown--active');
    });

    langLinks.forEach(link => {
      const href = link.getAttribute('href');

      if (
        (path === '/' && href === '/') ||
        (path.startsWith('/en') && href === '/en') ||
        (path.startsWith('/pt') && href === '/pt')
      ) {
        link.classList.add('lang-btn__dropdown-link--active');
      } else {
        link.classList.remove('lang-btn__dropdown-link--active');
      }
    });

  });

  // Legal page language dropdown
  const legalLangBtn = document.querySelector('[data-legal-lang]');
  if (legalLangBtn) {
    const dropdown = legalLangBtn.querySelector('.legal-header__lang-dropdown');

    legalLangBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      legalLangBtn.classList.toggle('legal-header__lang-btn--active');
    });

    document.addEventListener('click', () => {
      legalLangBtn.classList.remove('legal-header__lang-btn--active');
    });

    const langLinks = legalLangBtn.querySelectorAll('.legal-header__lang-link');
    langLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (path === href || path === href.replace(/\/$/, '')) {
        link.style.background = 'rgba(255,255,255,0.08)';
        link.style.color = '#fff';
      }
    });
  }
}
